export default __webpack_public_path__ + "static/media/product-1.f4b781b9.jpeg";